import Expense from "./routes/Expense/Expense.vue";
import Income from "./routes/Income/Income.vue";
import Summary from "./routes/Summary/Summary.vue";

const PnlDashboardRoutes = [
  {
    path: "Expense",
    name: "Expense",
    component: Expense,
  },
  {
    path: "Income",
    name: "Income",
    component: Income,
  },
  {
    path: "Summary",
    name: "Summary",
    component: Summary,
  }
];

export default PnlDashboardRoutes;
